import * as React from 'react';
import * as moment from 'moment';
import { BaseRouteProps } from '../../interfaces';
import { ExpiredOrganizationData } from '../../models';
import { OrganizationDataService } from '../../services';
import { LoadingIndicator } from '..';
import { DataGrid } from '../../components';
import { NavLink } from 'react-router-dom';

interface ExpiredOrganizationsState {
    data?: ExpiredOrganizationData;
}

export class ExpiredOrganizations extends React.Component<BaseRouteProps<{}>, ExpiredOrganizationsState> {
    private organizationDataService = new OrganizationDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{}>) {
        super(props);
        this.state = {};
    }

    public componentDidMount() {
        this.organizationDataService.getExpired().then(
            (response: ExpiredOrganizationData) => {
                this.setState({ data: response });
            }
        );
    }

    render() {
        if (!this.state.data) {
            return <LoadingIndicator />;
        }

        const { expiredOrganizations, expiringOrganizations } = this.state.data;

        const actionColumn = ({ value }: any) => {
            return (
                <span>
                    <NavLink to={`/Organization/${value}`} className="btn btn-default">View</NavLink>
                </span>
            );
        };

        const dateColumn = ({ value }: any) => {
            return (
                <span>{moment(value).format('L')}</span>
            );
        };

        const expiredListData = expiredOrganizations.map(entity => {
            return {
                'Name': entity.name,
                'ExpirationDate': entity.expirationDate,
                'ActionKey': entity.id
            };
        });

        const expiredSortKey = {
            id: 'Name',
            sortAscending: true
        };

        const expiringListData = expiringOrganizations.map(entity => {
            return {
                'Name': entity.name,
                'ExpirationDate': entity.expirationDate,
                'ActionKey': entity.id
            };
        });

        const expiringSortKey = {
            id: 'ExpirationDate',
            sortAscending: true
        };

        const columnDefs = [
            { id: 'Name' },
            { id: 'ExpirationDate', title: 'Expiration Date', width: '40%', customComponent: dateColumn },
            { id: 'ActionKey', title: 'Actions', width: '20%', customComponent: actionColumn, sortable: false }
        ];

        return (
            <div>
                <div className="content-header">
                    <div className="content-container">
                        <div className="title">
                            Expired Organizations
                        </div>
                    </div>
                </div>

                <div className="content-body">
                    <div className="content-container">
                        <h3>Expiring</h3>
                        <DataGrid
                            entities={expiringListData}
                            columns={columnDefs}
                            sortProperties={[expiringSortKey]}
                        />
                        <hr />
                        <h3>Expired</h3>
                        <DataGrid
                            entities={expiredListData}
                            columns={columnDefs}
                            sortProperties={[expiredSortKey]}
                        />
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ExpiredOrganizations/ExpiredOrganizations.tsx